import React, { Fragment, useState, useEffect } from 'react';
import {
  Button,
  Modal,
  Form,
  Row,
  Col,
  Container,
  Image
} from '@themesberg/react-bootstrap';
import { get, post, put } from '../../../services/back.service';
import { getBase64 } from '../../../utils/functions';
import ModalTriggerButton from '../../shared/ModalTriggerButton';

function ModalFormOffice({
  officeSelect,
  callback,
  title,
  button_text,
  button_variant,
}) {
  const [show, setShow] = useState(false);
  const [cities, setCity] = useState([]);
  const [image, setImage] = useState({});
  const [infoForm, setForm] = useState({
    name: '',
    address: '',
    city: '',
    phone: '',
    state: true,
    min_lat: 0,
    max_lat: 0,
    min_lon: 0,
    max_lon: 0,
  });

  const handleClose = () => setShow(false);
  const handleShow = async (office) => {
    if (office) {
      const infooffice = await get('/office/' + office);
      if (infooffice.success) {
        const { name, address, city, phone, state, min_lat, max_lat, min_lon, max_lon, image, name_image } = infooffice.data;
        setImage({
          name: name_image,
          base64: image,
          upload: false
        })
        setForm({ name, address, city, phone, state, min_lat, max_lat, min_lon, max_lon });
      }
    }
    setShow(true);
  };

  const handleForm = ({ target }) => {
    const value = target.type === 'checkbox' ? target.checked : target.value;
    setForm({ ...infoForm, [target.name]: value });
  };

  const saveForm = async (e) => {
    let respo,
      variant = '',
      msg = '';

    const body = { ...infoForm, image: image.base64, upload: image.upload, file_name: image.name };
    if (officeSelect) {
      respo = await put(
        '/office/modify/' + officeSelect,
        body,
      );
      msg = 'Tipo editado Correctamente';
    } else {
      respo = await post('/office/create', body);
      msg = 'Tipo Creado Correctamente';
    }

    if (respo.success) {
      variant = 'success';
    } else {
      variant = 'danger';
      msg = respo.message;
    }
    setForm({
      name: '',
      address: '',
      city: '',
      phone: '',
      state: true,
      min_lat: 0,
      max_lat: 0,
      min_lon: 0,
      max_lon: 0,
    });
    setImage({})
    handleClose();
    callback(variant, msg);
  };

  useEffect(() => {
    const initForm = () => {
      setCity([{ id: '1', name: 'Cali' }]);
    };

    initForm();
  }, []);

  const showConvertImage = async (e) => {
    const currentFile = e.target.files[0];
    const name = currentFile.name;
    const fileProcess = await getBase64(currentFile, name)
    setImage({
      name,
      base64: fileProcess.base64,
      upload: true
    })
  };

  return (
    <Fragment>
      <ModalTriggerButton
        button_variant={button_variant}
        button_text={button_text}
        onClick={() => handleShow(officeSelect)}
      />

      <Modal animation={false} fullscreen="sm-down" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Form.Label htmlFor="nombre">Nombre</Form.Label>
            <Form.Control
              name="name"
              value={infoForm.name}
              onChange={(e) => handleForm(e)}
              type="text"
            />
            <Form.Label htmlFor="direccion">Direccion</Form.Label>
            <Form.Control
              name="address"
              value={infoForm.address}
              onChange={(e) => handleForm(e)}
              type="text"
            />
            <Form.Label htmlFor="telefono">Telefono</Form.Label>
            <Form.Control
              name="phone"
              value={infoForm.phone}
              onChange={(e) => handleForm(e)}
              type="text"
            />
            <Form.Label htmlFor="ciudad">Ciudad</Form.Label>
            <Form.Select
              name="city"
              value={infoForm.city}
              onChange={(e) => handleForm(e)}
              aria-label="Default select example"
            >
              <option value="">Seleccione</option>
              {cities.map((element, i) => {
                return (
                  <option key={i} value={element.id}>
                    {element.name}
                  </option>
                );
              })}
            </Form.Select>
            <Form.Check
              className='mb-4'
              type="switch"
              name="state"
              label="Activo"
              checked={infoForm.state}
              onChange={(e) => handleForm(e)}
            />


            <Form.Group controlId="formFile" className="mb-3">
              <Form.Label>Logo Oficina</Form.Label>
              <Form.Control
                accept="image/*"
                type="file"
                onChange={(e) => { showConvertImage(e); }} />
            </Form.Group>
            <Image src={image.base64} rounded fluid />
            {image.base64
              && <div className='m-2'>
                <Button
                  variant="outline-primary"
                  onClick={() => setImage({})}
                >
                  Remover
                </Button>
              </div>}

            {/*
            <Form.Label htmlFor="latitud_min">Latitud Minima</Form.Label>
            <Form.Control
              name="min_lat"
              value={infoForm.min_lat}
              onChange={(e) => handleForm(e)}
              type="text"
            />

            <Form.Label htmlFor="latitud_max">Latitud Maxima</Form.Label>
            <Form.Control
              name="max_lat"
              value={infoForm.max_lat}
              onChange={(e) => handleForm(e)}
              type="text"
            />

            <Form.Label htmlFor="longitud_min">Longitud Minima</Form.Label>
            <Form.Control
              name="min_lon"
              value={infoForm.min_lon}
              onChange={(e) => handleForm(e)}
              type="text"
            />

            <Form.Label htmlFor="telefono">Longitud Maxima</Form.Label>
            <Form.Control
              name="max_lon"
              value={infoForm.max_lon}
              onChange={(e) => handleForm(e)}
              type="text"
            />
            */}

            <Row className="text-center m-3">
              <Col>
                <Button variant="secondary">Limpiar Formulario</Button>
              </Col>
              <Col>
                <Button
                  type="submit"
                  variant="primary"
                  onClick={(e) => saveForm(e)}
                >
                  Guardar Informacion
                </Button>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
    </Fragment>
  );
}

export default ModalFormOffice;
